export function WispLayer() {
  return (
    <>
      <style>{`
        @keyframes hero-wisp-a {
          from { transform: translate3d(0,0,0) rotate(-6deg) scaleX(1.4); }
          to   { transform: translate3d(60px,-8px,0) rotate(-4deg) scaleX(1.45); }
        }
        @keyframes hero-wisp-b {
          from { transform: translate3d(0,0,0) rotate(8deg); }
          to   { transform: translate3d(-48px,6px,0) rotate(6.5deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .hero-wisp { animation: none !important; }
        }
      `}</style>
      <div
        aria-hidden="true"
        id="hero-wisps"
        style={{
          position: 'absolute', inset: 0,
          pointerEvents: 'none', overflow: 'hidden', zIndex: 0,
        }}
      >
        <div
          className="hero-wisp"
          style={{
            position: 'absolute',
            top: '-8%', left: '-6%', width: '64%', height: '38%',
            borderRadius: '50%', filter: 'blur(72px)', willChange: 'transform',
            background: 'radial-gradient(ellipse 55% 65% at 42% 50%, rgba(255,252,240,0.95) 0%, rgba(253,246,222,0.65) 40%, rgba(248,238,208,0.25) 72%, rgba(245,238,217,0) 100%)',
            opacity: 0.85,
            animation: 'hero-wisp-a 180s linear infinite alternate',
          }}
        />
        <div
          className="hero-wisp"
          style={{
            position: 'absolute',
            top: '2%', right: '-14%', width: '48%', height: '26%',
            borderRadius: '50%', filter: 'blur(72px)', willChange: 'transform',
            background: 'radial-gradient(ellipse 60% 50% at 55% 45%, rgba(255,252,240,0.7) 0%, rgba(250,242,216,0.3) 55%, rgba(245,238,217,0) 100%)',
            opacity: 0.7,
            animation: 'hero-wisp-b 220s linear infinite alternate',
          }}
        />
      </div>
    </>
  )
}
